export default "__VITE_ASSET__DNOb7FAb__"